// components/HowItWorks.jsx
import React from "react";
import "./HowItWorks.css";
import { UserPlus, Settings, CreditCard, TrendingUp } from "lucide-react";

const HowItWorks = () => {
  const steps = [
    {
      icon: <UserPlus size={28} />,
      step: "01",
      title: "Sign Up",
      description:
        "Create your KadaiPOS account in under 2 minutes. No credit card required — start your free trial instantly.",
    },
    {
      icon: <Settings size={28} />,
      step: "02",
      title: "Configure",
      description:
        "Set up your menu, categories, pricing, taxes, and staff roles. Our team helps you with the initial setup.",
    },
    {
      icon: <CreditCard size={28} />,
      step: "03",
      title: "Start Billing",
      description:
        "Begin taking orders, generating bills, and managing your kitchen with KOT — everything works from day one.",
    },
    {
      icon: <TrendingUp size={28} />,
      step: "04",
      title: "Grow",
      description:
        "Use real-time analytics, inventory insights, and customer data to make smarter decisions and scale your business.",
    },
  ];

  return (
    <section className="section how-section">
      <div className="container">
        <h2 className="section-title">
          Get Started in <span className="gradient-text">4 Simple Steps</span>
        </h2>
        <p className="section-subtitle">
          From sign-up to your first bill in minutes. We make onboarding
          effortless so you can focus on what matters — your food.
        </p>

        <div className="how__grid">
          {steps.map((step, index) => (
            <div key={index} className="how__step">
              <div className="how__step-number">{step.step}</div>
              <div className="how__step-icon">{step.icon}</div>
              <h3 className="how__step-title">{step.title}</h3>
              <p className="how__step-desc">{step.description}</p>

              {/* Connector line (not on last) */}
              {index < steps.length - 1 && (
                <div className="how__connector" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
